module.exports = __webpack_public_path__ + "static/media/icon-email1.ef11d4bb.svg";